import { render } from "./FamilyHistoryRow.vue?vue&type=template&id=3c51e708&ts=true"
import script from "./FamilyHistoryRow.ts?vue&type=script&lang=ts&external"
export * from "./FamilyHistoryRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__